import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Layout } from '../components/Layout';
export function AboutPage() {
  return <Layout data-id="element-206">
      {/* Hero Section */}
      <section className="relative h-[40vh] md:h-[50vh] flex items-center justify-center overflow-hidden" data-id="element-207">
        <div className="absolute inset-0 z-0" data-id="element-208">
          <img src="https://cdn.magicpatterns.com/uploads/wmSkg482hFp8kjWmQevk6b/image.png" alt="About Us Background" className="w-full h-full object-cover brightness-[0.5]" data-id="element-209" />
          <div className="absolute inset-0 bg-black/20" data-id="element-210" />
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="relative z-10 text-4xl md:text-6xl font-bold text-white uppercase tracking-tighter text-center" data-id="element-211">
          About Us
        </motion.h1>
      </section>

      {/* Main Content */}
      <section className="py-16 px-6 bg-white" data-id="element-212">
        <div className="max-w-7xl mx-auto" data-id="element-213">
          <div className="flex flex-col lg:flex-row gap-12 items-start mb-16" data-id="element-214">
            <div className="flex-1 space-y-8" data-id="element-215">
              <h2 className="text-4xl font-black text-[#6B0D24] uppercase tracking-tight" data-id="element-216">
                About Us
              </h2>
              <div className="space-y-6 text-charcoal/70 leading-relaxed text-lg" data-id="element-217">
                <p className="text-xl font-medium text-charcoal" data-id="element-218">
                  Since 2003, we've delivered premium kitchen and bathroom
                  transformations with a focus on quality, value, and
                  uncompromising craftsmanship.
                </p>
                <p data-id="element-219">
                  By working directly with local manufacturers, we eliminate
                  middleman costs, ensuring you get the highest quality
                  cabinetry and flooring at the best possible price.
                </p>
                <p data-id="element-220">
                  Our specialists are dedicated to bringing your vision to life
                  with expert design consultation and precision installation
                  tailored to your lifestyle.
                </p>
              </div>
            </div>
            <div className="flex-1 w-full" data-id="element-221">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} className="shadow-2xl border border-charcoal/5" data-id="element-222">
                <img src="https://cdn.magicpatterns.com/uploads/iTbvu3C4vkWTXNBvrVaCFr/about.png" alt="Modern Kitchen Design" className="w-full h-auto object-cover" data-id="element-223" />
              </motion.div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-224">
            <div className="space-y-8" data-id="element-225">
              <h2 className="text-3xl font-black text-[#6B0D24] uppercase tracking-tight" data-id="element-226">
                Why Choose Us
              </h2>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-227">
                We simplify the renovation process, providing expert guidance
                and premium products to ensure your project is seamless from
                start to finish.
              </p>
              <ul className="space-y-4" data-id="element-228">
                {['In service since 2003', 'Experienced Staff', 'Quality Materials'].map(item => <li key={item} className="flex items-center gap-3 text-charcoal/80 font-bold" data-id="element-229">
                    <CheckIcon size={20} className="text-[#6B0D24]" strokeWidth={3} data-id="element-230" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="space-y-8" data-id="element-231">
              <h2 className="text-3xl font-black text-[#6B0D24] uppercase tracking-tight" data-id="element-232">
                Guidelines For Choosing Cabinets
              </h2>
              <ul className="space-y-4" data-id="element-233">
                {['Exact measurement of appliances involved in the design', 'Duration of stay in the home', 'Layout desired', 'Standard improvements of similar homes in the area', 'Budget'].map(item => <li key={item} className="flex items-center gap-3 text-charcoal/80 font-bold" data-id="element-234">
                    <CheckIcon size={20} className="text-[#6B0D24]" strokeWidth={3} data-id="element-235" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}